module.exports = __webpack_public_path__ + "img/names-I-like-logo-inverted.2c69262b.svg";